function alerta( mensaje, tipo, tmp ) {
	if ( !tmp ) {
		Swal.fire( {
			title: '',
			text: mensaje,
			icon: tipo,
			confirmButtonText: 'Ok'
		} );
	} else {
		Swal.fire( {
			title: '',
			text: mensaje,
			icon: tipo,
			showConfirmButton: false,
			timer: 2000
		} );
	}
}
function alertaCallBack( mensaje, tipo, callback ) {
	Swal.fire( {
		title: '',
		text: mensaje,
		icon: tipo,
		confirmButtonText: 'Ok'
	} ).then( function() {
		if ( typeof callback === 'function' ) { callback(); }
	} );
}
function confirmacion( titulo, pregunta, successCallback ) {
	Swal.fire( {
		title: titulo,
		text: pregunta,
		icon: 'warning',
		showCancelButton: true,
		confirmButtonText: 'SI',
		cancelButtonText: 'NO'
	} ).then( ( result) => {
		if (result.isConfirmed) { successCallback( true ); }
		 else { successCallback( false ); }
	} );
}
function chooseOption( titulo, pregunta, inputOptions, successCallback ) {
	Swal.fire( {
		title: titulo,
		text: pregunta,
		input: 'radio',
		inputOptions: inputOptions,
		inputValidator: (value) => {
			if (!value) {
				return false
			} else {
				successCallback( value )
			}
		}
	} )
}
function ingresaDato( pregunta, type, defaultTxt, successCallback ) {
	Swal.fire( {
		text: pregunta,
		input: type,
		inputValue: defaultTxt,
		showCancelButton: true,
		confirmButtonText: 'Confirmar',
	} ).then( ( input ) => {
		successCallback( input );
	} );
}
function manda( url ) {
	location.href = url;
}
function cargando( status ) {
	if ( !status ) {
		$( '.loader' ).attr( 'aria-hidden', true );
		$( '.loader' ).fadeOut( "slow" );
		$( '.capaNegra' ).fadeOut( 'slow' );
		$( '.loader' ).attr( 'aria-live', '' );
	} else {
		$( '.loader' ).attr( 'aria-hidden', false );
		$( '.loader' ).fadeIn( 'slow' );
		$( '.capaNegra' ).fadeIn( 'slow' );
		$( '.loader' ).attr( 'aria-live', 'assertive' );
	}
}
function ajaxRequest( load, tipo, parametros, urlCall, successCallback ) {
	$.ajax( {
		type: tipo,
		url: urlCall,
		data: parametros,
		async: true,
		beforeSend: function() { if ( load ) { cargando( true ) } },
		success: function( respuesta ) { successCallback( respuesta ); },
		error: function() {
			if ( load ) { cargando( false ) }
			var mensaje = idioma == 'ES' ? 'Hubo un problema, intenta de nuevo' : 'There was a problem, please try again';
			alerta( mensaje, 'error', true );
		},
		statusCode: { 404:
			function() {
				if ( load ) { cargando( false ) }
				var mensaje = idioma == 'ES' ? 'Archivo de petición no encontrado' : 'Request file not found';
				alerta( mensaje, 'error', true );
			}
		}
	} );
}
function checaSesion( parametro ) {
	if ( localStorage.getItem( parametro ) === null || localStorage.getItem( parametro ) === '' || localStorage.getItem( parametro ) === 'null' ) {
		return false;
	} else {
		return true;
	}
}
function seteaSesion( nombre, valor ) { localStorage.setItem( nombre, valor ); }
function obtenSesion( parametro ) { return localStorage.getItem( parametro ); }
function borraSesion( parametro ) { localStorage.removeItem( parametro ); }
function cleanupPlacePopup() {
	if ( typeof selectedFiles !== 'undefined' ) { selectedFiles = []; }
	if ( typeof imageChange !== 'undefined' ) { imageChange = false; }
	$( '#fileList' ).html( '' );
	const $input = $( '#placeImages' );
	if ( $input.length ) {
		$input.val( '' );
		if ( $input[ 0 ] ) {
			try { $input[ 0 ].files = new DataTransfer().files; } catch ( e ) {}
		}
	}
}
function popup( cual, status ) {
	if ( status ) {
		currentModal = cual;
		$( '#' + cual ).modal( {
			fadeDuration: 500,
  			fadeDelay: 0.3,
			escapeClose: false,
			clickClose: false
		} );
		$( '#' + cual ).attr( 'aria-hidden', false );
		setTimeout( function() {
			let $primerInput = $( '#' + cual ).find( 'input, select, textarea' ).filter( ':visible' ).first();
			console.log( $primerInput );
			if ( $primerInput.length ) {
				$primerInput.trigger( 'focus' );
			} else {
				let $primerButton = $( '#' + cual ).find( '.button' ).filter( ':visible' ).first();
				if ( $primerButton.length ) {
					$primerButton.trigger( 'focus' );
				}  else {
					$( '#' + cual ).trigger( 'focus' );
				}
			}
		}, 300 );
	} else {
		currentModal = '';
		$( '#' + cual ).attr( 'aria-hidden', true );
		$.modal.close();
		if ( $( '#' + cual + ' form' ).length ) {
			$( '#' + cual + ' form' )[0].reset();
		}
		if ( cual === 'placePopup' ) { cleanupPlacePopup(); }
	}
}
function moveAnimate( anchor ){
    var aTag = $( '#' + anchor );
    $( 'html, body' ).animate( { scrollTop: aTag.offset().top }, 'slow' );
}
function soloNumeros( e ) {
	var keynum = window.event ? window.event.keyCode : e.which;
	if ( ( 8 === keynum ) || ( 46 === keynum ) || ( 0 === keynum ) ) {
		return true;
	} else {
		return /\d/.test( String.fromCharCode( keynum ) );
	}
}
function numberFormat( nStr ) {
	nStr += '';
	var x = nStr.split('.');
	var x1 = x[0];
	var x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	x2 = ( x2.length > 2 ) ? x2.substr( 0 , 3 ) : x2;
	var numeroFinal = x1 + x2;
	return numeroFinal;
}
function limpiarTexto( texto ) {
	return texto
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")
		.replace(/[^a-zA-Z0-9\s-]/g, "")
		.trim()
		.replace(/\s+/g, "-")
		.replace(/-+/g, "-")
		.toLowerCase();
}
function validarEmail( email ) {
	let input = document.createElement( 'input' );
	input.type = 'email';
	input.value = email;
	return input.checkValidity();
}
function validaForm( contenedor ) {
	let valido = true;
	$( '#' + contenedor + ' span.error' ).html( '' );
	$( '#' + contenedor + ' input[type="text"], #' + contenedor + ' input[type="email"], #' + contenedor + ' input[type="password"], #' + contenedor + ' input[type="hidden"], #' + contenedor + ' input[type="number"], #' + contenedor + ' input[type="tel"], #' + contenedor + ' select' ).each( function() {
		let id = $( this ).attr( 'id' );
		let valor = $.trim( $( this ).val() );
		let tipo = $( this ).prop( 'type' );
		let error = '';
		const label = $( 'label[for="' + id + '"]' ).text().replace( '*', '' ).replace( '(opcional)', '' ).trim();
		if ( $( this ).prop( 'required' ) && valor == '' ) {
			if ( $( this ).is( 'select' ) ) {
				error = idioma == 'ES' ? 'El campo ' + label + ' es obligatorio (debe elegir al menos una opción)' : 'The field ' + label + ' is required (must select at least one option)';
			} else {
				if ( $( this ).is( 'input[type="checkbox"]' ) || $( this ).is( 'input[type="radio"]' ) ) {
					error = idioma == 'ES' ? 'Debe seleccionar esta opción' : 'This option is required';
				} else {
					if ( $( this ).is( 'input[type="email"]' ) || $( this ).is( 'input[type="email"]' ) ) {
						error = idioma == 'ES' ? 'El campo ' + label + ' es obligatorio (debe contener un formato de mail válido)' : 'The field ' + label + ' is required (must contain a valid email format)';
					} else {
						if ( id == 'puntuacion' ) {
							error = idioma == 'ES' ? 'El campo ' + label + ' es obligatorio (debe puntuar el lugar con al menos una estrella)' : 'The field ' + label + ' is required (must rate the place with at least one star)';
						} else {
							error = idioma == 'ES' ? 'El campo ' + label + ' es obligatorio (debe contener al menos dos caracteres)' : 'The field ' + label + ' is required (must contain at least two characters)';
						}					}
				}
			}
		}
		if ( error == '' && valor != '' && tipo == 'email' ) {
			if ( !validarEmail( valor ) ) {
				error = idioma == 'ES' ? 'Ingrese un formato de email válido' : 'Enter a valid email address';
			}
		}
		if ( error == '' && valor != '' && tipo == 'number' ) {
			if ( isNaN( valor ) ) {
				error = idioma == 'ES' ? 'Ingrese un número válido' : 'Enter a valid number';
			}
		}
		if ( error == '' && valor != '' && tipo == 'tel' ) {
			let telLimpio = valor.replace( /[^0-9]/g, '' );
			if ( telLimpio.length < 10 ) {
				error = idioma == 'ES' ? 'Ingrese un teléfono válido' : 'Enter a valid phone number';
			}
		}
		if ( error == '' && valor != '' && $( this ).attr( 'minlength' ) ) {
			let min = parseInt( $( this ).attr( 'minlength' ) );
			if ( valor.length < min ) {
				error = idioma == 'ES' ? 'El campo ' + label + ' Debe tener al menos ' + min + ' caracteres' : 'The field ' + label + ' Must contain at least ' + min + ' characters';
			}
		}
		if ( error == '' && valor != '' && $( this ).attr( 'maxlength' ) ) {
			let max = parseInt( $( this ).attr( 'maxlength' ) );
			if ( valor.length > max ) {
				error = idioma == 'ES' ? 'El campo ' + label + ' no debe exceder ' + max + ' caracteres' : 'The field ' + label + ' must not exceed ' + max + ' characters';
			}
		}
		if ( error == '' && valor != '' && $( this ).attr( 'pattern' ) ) {
			let pattern = new RegExp( $( this ).attr( 'pattern' ) );
			if ( !pattern.test( valor ) ) {
				error = idioma == 'ES' ? 'El formato del campo ' + label + ' no es válido' : 'The format of the field ' + label + ' is not valid';
			}
		}
		if ( $( this ).attr( 'type' ) == 'password' && valor.length < 6 ) {
			error = idioma == 'ES' ? 'El campo ' + label + ' debe tener al menos 6 caracteres' : 'The field ' + label + ' must contain at least 6 characters';
		}
		if ( error != '' ) {
			valido = false;
			$( this ).addClass( 'error' );
			$( 'span.error[data-error-for="' + id + '"]' ).html( error );
			$( 'span.error[data-error-for="' + id + '"]' ).attr( 'id', 'error-' + id);
			$( 'span.error[data-error-for="' + id + '"]' ).attr( 'role', 'alert' );
			$( this ).attr( 'aria-invalid', true );
			$( this ).attr( 'aria-describedby', 'error-' + id );
			$( this ).off( 'change.validaForm' ).on( 'change.validaForm', function() {
				validaForm( contenedor );
			} );
		} else {
			$( this ).removeClass( 'error' );
			$( 'span.error[data-error-for="' + id + '"]' ).removeAttr( 'role' );
			$( this ).attr( 'aria-invalid', false );
			$( this ).removeAttr( 'aria-describedby' );
			$( this ).off( 'change.validaForm' );
		}
	} );
	$( '#' + contenedor + ' textarea' ).each( function() {
		let id = $( this ).attr( 'id' );
		let error = '';
		const label = $( 'label[for="' + id + '"]' ).text().replace( '*', '' ).replace( '(opcional)', '' ).trim();
		if ( $( this ).hasClass( 'htmlEditor' ) ) {
			if ( $( this ).prop( 'required' ) && obtenHtml( id ).trim() == '' ) {
				error = idioma == 'ES' ? 'El campo ' + label + ' es obligatorio (debe contener al menos dos caracteres)' : 'The field ' + label + ' is required (must contain at least two characters)';
			}
		} else {
			if ( $( this ).prop( 'required' ) && ( $( this ).val().trim() == '' || $( this ).val().trim().length < 2 ) ) {
				error = idioma == 'ES' ? 'El campo ' + label + ' es obligatorio (debe contener al menos dos caracteres)' : 'The field ' + label + ' is required (must contain at least two characters)';
			}
		}
		if ( error != '' ) {
			valido = false;
			$( this ).addClass( 'error' );
			$( 'span.error[data-error-for="' + id + '"]' ).html( error );
			$( 'span.error[data-error-for="' + id + '"]' ).attr( 'id', 'error-' + id);
			$( 'span.error[data-error-for="' + id + '"]' ).attr( 'role', 'alert' );
			$( this ).attr( 'aria-invalid', true );
			$( this ).attr( 'aria-describedby', 'error-' + id );
			$( this ).off( 'change.validaForm' ).on( 'change.validaForm', function() {
				validaForm( contenedor );
			} );
		} else {
			$( this ).removeClass( 'error' );
			$( 'span.error[data-error-for="' + id + '"]' ).removeAttr( 'role' );
			$( this ).attr( 'aria-invalid', false );
			$( this ).removeAttr( 'aria-describedby' );
			$( this ).off( 'change.validaForm' );
		}
	} );
	$( '#' + contenedor + ' input[type="checkbox"][required], #' + contenedor + ' input[type="radio"][required]' ).each( function() {
		let nombre = $( this ).attr( 'name' );
		let id = $( this ).attr( 'id' );
		let error = '';
		if ( $( this ).prop( 'type' ) == 'checkbox' && !$( this ).is( ':checked' ) ) {
			error = idioma == 'ES' ? 'Debe seleccionar esta opción' : 'This option is required';
		}
		if ( $( this ).prop( 'type' ) == 'radio' && $( 'input[name="' + nombre + '"]:checked' ).length == 0 ) {
			error = idioma == 'ES' ? 'Debe seleccionar una opción' : 'Please select an option';
		}
		if ( error != '' ) {
			valido = false;
			$( this ).addClass( 'error' );
			$( 'span.error[data-error-for="' + id + '"]' ).html( error );
			$( 'span.error[data-error-for="' + id + '"]' ).attr( 'id', 'error-' + id);
			$( 'span.error[data-error-for="' + id + '"]' ).attr( 'role', 'alert' );
			$( this ).attr( 'aria-invalid', true );
			$( this ).attr( 'aria-describedby', 'error-' + id );
		} else {
			$( this ).removeClass( 'error' );
			$( 'span.error[data-error-for="' + id + '"]' ).removeAttr( 'role' );
			$( this ).attr( 'aria-invalid', false );
			$( this ).removeAttr( 'aria-describedby' );
		}
	} );
	if ( !valido ) {
		moveAnimate( contenedor );
		let $primerError = $( '#' + contenedor ).find( 'input.error, select.error, textarea.error' ).filter( function() {
			let el = this;
			if ( el.disabled ) {
				return false;
			}
			if ( el.tagName === 'INPUT' ) {
				let ty = el.type;
				if ( ty === 'hidden' || ty === 'button' || ty === 'submit' ) {
					return false;
				}
			}
			return $( el ).is( ':visible' );
		} ).first();
		if ( $primerError.length ) {
			$primerError.trigger( 'focus' );
		}
	}
	return valido;
}